module.exports = __webpack_public_path__ + "static/img/2284_phase_function_Paper_PointsHejduk_Prediction.d232303.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2284_phase_function_Paper_PointsHejduk_Prediction.png
// module id = caRx
// module chunks = 0